import React, { useState, useEffect, useContext } from 'react';
import { ApplicationContext } from '../../../context/Application.context';
import { validateCompleteDesignatedContact } from '../../../constants/cardComplete';
import { entities } from '../../../constants';
import SlidePanel from '../../SlidePanel';
import styles from '../Application.module.scss';
import EntityList from '../../EntityList';
import AddContact from './AddContact';
import getConfig from '../../../config';

const FLAG = 'isAuthorizedUser';

const contactObj = {
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  email: '',
  title: null
};

const AuthorizedUsersTab = ({ peopleList, onPersonAdd, onPersonUpdate, onPersonRemove }) => {
  const [state] = useContext(ApplicationContext);
  const [slidePane, setSlidePane] = useState(false);
  const [contactView, setContactView] = useState(null);
  const contactTotal = peopleList.filter(person => person[FLAG]).length;
  const contactTotalTitle = `${contactTotal} out of 2 Authorized Users`;
  const authorizedUserList = peopleList.filter(person => person[FLAG]);
  const prevAddedList = peopleList.filter(person => !person[FLAG] && (person.isOfficer || person.isDirector || person.isPrimaryContact || person.isPrimaryBillingContact));
  const isReadOnly = state.readOnly;
  const showIncompletes = state.showIncompletes;
  let authorizedUserTitle = `${contactView && contactView.firstName} ${contactView && contactView.lastName}`;
  let existingContactAffiliation = null;

  if (!authorizedUserTitle || authorizedUserTitle.trim().length === 0) authorizedUserTitle = entities.NO_NAME;

  if (contactView && contactView.isOfficer) existingContactAffiliation = 'Officer';
  if (contactView && contactView.isDirector) existingContactAffiliation = 'Director';
  if (contactView && contactView.isOfficer && contactView.isDirector) existingContactAffiliation = 'Officer, Director';

  useEffect(() => {
    if (!slidePane) setContactView(null);
  }, [slidePane]);

  const handleUpdate = contact => {
    onPersonUpdate(contact);
    setSlidePane(false);
  };

  const handleAdd = contact => {
    onPersonAdd(contact);
    setSlidePane(false);
  };

  const handleEdit = contact => {
    setContactView(contact);
    setSlidePane(true);
  };

  const handleRemove = (e, contact) => {
    e.stopPropagation();
    onPersonRemove(contact, FLAG);
  };

  const validateComplete = contact => {
    return validateCompleteDesignatedContact(contact, FLAG);
  };

  const entityTitle = contact => {
    const title = `${contact.firstName} ${contact.lastName}`;
    if (!title || title.trim().length === 0) return entities.NO_NAME;

    return title;
  };

  const iqBaseUrl = getConfig()?.IQ_BASE_URL ?? 'https://otciq.com';

  return (
    <div data-testid="authorized-users-tab">
      <p className={styles.description}>
        Designate up to two persons to access <a href={iqBaseUrl} target='_blank' rel='noopener noreferrer'>OTCIQ.com</a>, our secure web portal used to publish disclosure and news, update company profile information, and view trade data.<br />These individuals do not need to be Officers or Directors, but must be authorized representatives who can login on behalf of the company.
      </p>
      <EntityList
        testId='authorized-users-entity-list'
        addTestId='authorized-users-add'
        itemTestId={(_item, i) => `authorized-user-entity-${i}`}
        title={contactTotalTitle}
        addTitle={contactTotal < 2 && 'Add Authorized User'}
        showIncompleteList={showIncompletes && contactTotal < 1}
        showIncompletes={showIncompletes}
        incompleteMessage='One Authorized Users is required.'
        icon={'user'}
        iconComplete={'userComplete'}
        readOnly={isReadOnly}
        list={authorizedUserList}
        confirmRemoveText={entities.CONFIRM_REMOVE_PERSON}
        entityTitle={entityTitle}
        validateComplete={validateComplete}
        handleAddClick={() => setSlidePane(true)}
        handleEntityClick={handleEdit}
        handleEntityRemove={!isReadOnly && handleRemove} />
      <SlidePanel
        isOpen={slidePane}
        onClose={() => setSlidePane(false)}
        title={contactView ? authorizedUserTitle : 'Add Authorized User'}
        subTitle={existingContactAffiliation && existingContactAffiliation}>
        <AddContact
          contactType='Authorized User'
          prevAddDesc='Select an individual previously entered, or Add a New Authorized User.'
          addNewDesc='Enter title and name of Authorized User.'
          flag={FLAG}
          contactObj={contactObj}
          contactView={contactView}
          setContactView={setContactView}
          prevAddedList={prevAddedList}
          handleUpdate={handleUpdate}
          handleAdd={handleAdd}
          setSlidePane={setSlidePane} />
      </SlidePanel>
    </div>
  );
};

export default AuthorizedUsersTab;
